import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { applyTheme, getTheme } from './themes';
import { GoogleOAuthProvider } from '@react-oauth/google';


const GCP_CLIENT_ID = "302792922407-35tganvo0blbkn2rdrfat1c7isuoiquv.apps.googleusercontent.com"
// Apply theme IMMEDIATELY based on port
const port = window.location.port;
const themeMap = {
  '3000': 'purple',
  '3010': 'green',
  '3020': 'pink'
};
const themeName = process.env.REACT_APP_THEME || 'green';
console.log('Initial theme:', themeName);
applyTheme(getTheme(themeName));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <GoogleOAuthProvider clientId={GCP_CLIENT_ID}>
    <App />
   </GoogleOAuthProvider>
  </React.StrictMode>
);